var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{directives:[{name:"currency",rawName:"v-currency",value:(_vm.options),expression:"options"}],ref:"input",attrs:{"value":_vm.formattedValue,"prependIcon":"mdi-currency-eur"},on:{"change":_vm.onChange,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }